module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAxCAYAAACYq/ofAAAAtklEQVRoge3YwQ3CMBBE0QmiAVqgBVpIWtkaKIEa3Aq0kBZSC7Lk63JhLb7QvGskr/8hPuyiCSJilfRMTt5aa6/qqacZIb/gEBqH0DiExiE0DqFxCI1DaBxC4xCaJSIukm7F9+rnPZJvd0l78bz9PIZmi4IZssBvbP5HaBxC8zch/dU6xpNY6do3p8l5bcysdHj3S+MQGofQOITGITQOoXEIjUNoHELjEJq+fJjh00KjevEgSXoDfq4WzMCVDdEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jia.png
// module id = M9DV
// module chunks = 63